import { FC } from "react"

import { Chip, Stack, Typography } from "@mui/material"
import Dialog from "components/common/dialog/dialog"
import { useTranslation } from "react-i18next"

interface IProps {
  open: boolean
  groupNames: string[]
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteGroupsDialog: FC<IProps> = ({
  open,
  groupNames,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      isLoading={isLoading}
      titleText={t("group.deleteDialogTitle")}
      actionAcceptText={t("group.deleteDialogConfirm")}
      onActionButtonClick={onConfirm}
      actionAcceptButtonProps={{ disabled: isLoading, color: "primary" }}
      tabletMaxWidth="440px"
    >
      <Stack gap="24px">
        <Stack direction="row" flexWrap="wrap" gap="8px">
          {groupNames.map((name) => (
            <Chip
              key={name}
              label={name}
              size="small"
              sx={{
                bgcolor: "mockup.neutral95",
                color: "mockup.neutral10",
                fontWeight: 600,
              }}
            />
          ))}
        </Stack>
        <Typography variant="body1" fontWeight={500} color="mockup.neutral10">
          {t("group.deleteDialogWarning")}
        </Typography>
      </Stack>
    </Dialog>
  )
}

export default DeleteGroupsDialog
